import { ReactNode, useEffect, useState, createContext } from 'react';

import { Config, loadConfig } from '@/config/config';

export const ConfigContext = createContext<Config | null>(null);

type ConfigProviderProps = {
  children: ReactNode;
  onLoad?: (config: Config) => void;
};

export function ConfigProvider(props: ConfigProviderProps) {
  const { onLoad } = props;
  const [config, setConfig] = useState<Config | null>(null);

  useEffect(() => {
    (async () => {
      const c = await loadConfig();
      onLoad?.(c);
      setConfig(c);
    })();
  }, [onLoad, setConfig]);

  if (!config) {
    return null;
  }
  return <ConfigContext.Provider value={config}>{props.children}</ConfigContext.Provider>;
}
